export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_15_08.Still002.d3c61a6c.jpg";